export default {
  required: 'Campo obrigatório'
}
